import { Box } from '@mui/material';
import { useMemo } from 'react';
import FilterChip, { FilterChipProps } from './filter-chip.component';

type ArrayFilterChipProps = Omit<FilterChipProps, 'value'> & {
  value: string[];
  limit?: number;
};

const ArrayFilterChip = ({
  value,
  limit = 1,
  ...rest
}: ArrayFilterChipProps) => {
  const visible = useMemo(() => value.slice(0, limit), [limit, value]);
  const hidden = useMemo(() => value.slice(limit), [limit, value]);

  return (
    <FilterChip
      value={
        <Box display="flex">
          {visible.map((item, i) => (
            <Box display="flex" mr={0.35} key={item}>
              <Box
                maxWidth="152px"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                overflow="hidden"
                title={item}
              >
                {item}
              </Box>
              <Box>
                {(i < visible.length - 1 ||
                  (hidden.length > 0 && i === visible.length - 1)) &&
                  ','}
              </Box>
            </Box>
          ))}
          {hidden.length > 0 && <Box>+{hidden.length}</Box>}
        </Box>
      }
      {...rest}
    />
  );
};

export default ArrayFilterChip;
